// extracted by mini-css-extract-plugin
module.exports = {"title":"entity_outline_title-module__title--16WVg"};